var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-select',{attrs:{"id":"input:tipoOperacao","items":_vm.tipoOperacaoOption,"label":"Tipo operação","loading":_vm.loading,"disabled":_vm.isEdit},model:{value:(_vm.payload.tipoOperacao),callback:function ($$v) {_vm.$set(_vm.payload, "tipoOperacao", $$v)},expression:"payload.tipoOperacao"}})
}
var staticRenderFns = []

export { render, staticRenderFns }